import { NgModule, ModuleWithProviders } from '@angular/core';

import { FroalaEditorDirective } from './editor.directive';



export class FroalaEditorModule {
  public static forRoot(): ModuleWithProviders {
    return {ngModule: FroalaEditorModule, providers: []};
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FroalaEditorDirective],
  exports: [FroalaEditorDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
